import { Box, Typography } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
// import { amber, dark, middark, green, red } from "../variables";
import { dark } from "../variables";

// When we have normalised statuses in the search response, use this for colour
// coding. Until then, this just uses the old bluish colour.
// const getStatusColor = (legalStatus: string): string => {
//     switch (legalStatus.toLowerCase()) {
//         case "active":
//             return green; // Green for active
//         case "inactive":
//             return red; // Red for inactive
//         case "distressed":
//             return amber; // Amber for distressed
//         default:
//             return middark; // Default color for unknown status
//     }
// };

export const LegalStatus = ({
    legalStatus,
}: {
    legalStatus: string | null;
}) => {
    if (!legalStatus) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gridColumnStart: "1 / span 1",
            }}
        >
            <CircleIcon
                sx={{
                    width: "0.5em",
                    height: "0.5em",
                    marginRight: 1,
                    color: "#004257",
                }}
            />
            <Typography variant="caption" color={dark}>
                {legalStatus}
            </Typography>
        </Box>
    );
};
